import React from "react";

import LinearProgress from "@material-ui/core/LinearProgress";

import { get } from "lodash";
class Row extends React.Component {
  render() {
    const { row } = this.props;
    const isUploading = get(row, "isUploading", false);
    const progress = get(row, "progress", 0);

    if (isUploading) {
      return (
        <tr className="is-uploading">
          <td colspan="10">
            <div className="uploading">
              <LinearProgress variant="determinate" value={progress} />
            </div>
          </td>
        </tr>
      );
    }

    return null;
  }
}

export default Row;
